var MATCH_PDF_FILE = /\.(pdf)($|\?)/i;
var canPlay = function canPlay(url) {
  return MATCH_PDF_FILE.test(url);
};
export default canPlay;